import { ajax } from "lib/observable";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import siteConfig from "site-config";
import { SIZE_COMPLIANCE_REPORT } from "constants/action-types";
import { add as snackbarAdd } from "../actions/snackbars";
import { formatMessage } from "lib/globalize-util";

export const createSizeFamiliesEpic = (action$, store) =>
    action$
        .ofType(SIZE_COMPLIANCE_REPORT.CREATE.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap((sizeFamily) => {
            return ajax({
                url: `${siteConfig.api}/api/v3.0/items/export/size-compliance`,
                method: "POST",
                withCredentials: true,
                crossDomain: true,
            })
                .flatMap(({ response }) => [
                    {
                        payload: response.id,
                        type: SIZE_COMPLIANCE_REPORT.CREATE.COMPLETED,
                    },
                ])
                .catch((error) =>
                    Observable.merge(
                        Observable.of({
                            error: true,
                            payload: error,
                            type: SIZE_COMPLIANCE_REPORT.CREATE.COMPLETED,
                        }),
                        Observable.of(
                            snackbarAdd({ message: formatMessage("There was an error generating compliance report") }),
                        ),
                    ),
                );
        });
